import { render, staticRenderFns } from "./eproModel.vue?vue&type=template&id=583c53dc&scoped=true"
import script from "./eproModel.vue?vue&type=script&lang=js"
export * from "./eproModel.vue?vue&type=script&lang=js"
import style0 from "./eproModel.vue?vue&type=style&index=0&id=583c53dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c53dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583c53dc')) {
      api.createRecord('583c53dc', component.options)
    } else {
      api.reload('583c53dc', component.options)
    }
    module.hot.accept("./eproModel.vue?vue&type=template&id=583c53dc&scoped=true", function () {
      api.rerender('583c53dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/infoFrom/eproModel.vue"
export default component.exports